import {
    apiRequest,
    bankCreate
} from "../../../../../services/adapters/master/bankService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", bankCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository